module.exports = __webpack_public_path__ + "media/src/assets/images/ai-bg-fd67e325fcde0813fabda2b24ed88964.jpg";